import React, { useMemo } from 'react';
import { analyticsSnapshot } from '../../data/analyticsSnapshot';
import MetricSummary from '../common/MetricSummary';
import { sumArray } from '../../utils/dataHelpers';
import ChartCard from '../common/ChartCard';
import { ChartData, ChartOptions } from 'chart.js';

const WebAttributionPage: React.FC = () => {
  const attribution = analyticsSnapshot.crossChannelAnalysis.attribution;
  const channelTotals = attribution.channelContributions.datasets
    .map((dataset) => ({
      label: dataset.label,
      total: sumArray(dataset.data)
    }))
    .sort((a, b) => b.total - a.total)
    .slice(0, 3);
  const insights = analyticsSnapshot.aiAnalysis.crossChannelAnalysis.attribution.insights;

  const chartData = useMemo<ChartData<'bar'>>(
    () => ({
      labels: Array.from(attribution.channelContributions.labels),
      datasets: attribution.channelContributions.datasets.map((dataset) => ({
        label: dataset.label,
        data: Array.from(dataset.data),
        stack: 'stack1'
      }))
    }),
    [attribution.channelContributions.labels, attribution.channelContributions.datasets]
  );

  const chartOptions: ChartOptions<'bar'> = useMemo(
    () => ({
      scales: {
        x: {
          stacked: true
        },
        y: {
          stacked: true
        }
      }
    }),
    []
  );

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold text-white">Attribution Analizi</h1>
        <p className="text-white/70 mt-2">
          Çok kanallı modellemede hangi kanalların dönüşümlere daha fazla katkı sunduğunu inceleyin.
        </p>
        <div className="mt-2 text-sm text-white/50">Model: {attribution.model}</div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {channelTotals.map((channel) => (
          <MetricSummary
            key={channel.label}
            title={`${channel.label} Katkısı`}
            value={channel.total}
            description="Toplam katkı puanı"
          />
        ))}
      </div>

      <ChartCard
        title="Aylık Kanal Katkıları"
        description="Kanal başına dönüşüm katkısının zaman içindeki dağılımı."
        data={chartData}
        chartType="bar"
        options={chartOptions}
        insights={insights}
      />

    </div>
  );
};

export default WebAttributionPage;

